import { inject, Injectable, signal } from '@angular/core';
import { ActionQueryService } from '../api/queries/action-query.service';

// Root-scoped: the layout badge outlives any one page-scoped ActionStore and must update
// when mutations run on Actions, Company, Delegate, or Schedule.
@Injectable({ providedIn: 'root' })
export class OutstandingActionsCountService {
    private readonly _queryService = inject(ActionQueryService);
    readonly count = signal(0);

    loadOutstandingActionsCount(): void {
        this._queryService.getOutstandingActionsCount().subscribe((response) => {
            this.count.set(response.count);
        });
    }
}
